export default __webpack_public_path__ + "6641bf1858ce118f330b4334eed61c5c.png";